module.exports = __webpack_public_path__ + "img/1.000a14fc.png";